import getTimestamp from "../utils/getTimestamp";
import StorageService from "../services/StorageService";
import Device from "../utils/Device";
const isSessionNotify = (key) => key.split("-")[1] === "session";
const isStorageSupported = isLocalStorage() && isSessionStorage();
const notifyElements = {
    notifySelector: ".js-notify",
    notifyOldBrowserSelector: "#notification-old-browser",
    notifyStorageSelector: ".js-notify-storage",
    notifyCloseClassName: "js-notify-close",
    notifyHiddenClass: "is-hidden",
};
/**
 * Check for not supported browser.
 *
 * Note that this code won't execute in case of JS errors, so essential checks are in pendolino `_scripts.html.erb`.
 *
 * TODO: Implement feature detection.
 */
function isNotSupportedBrowser() {
    return Device.getBrowserName() === "Internet Explorer";
}
function getCurrentTimeInSeconds() {
    return new Date().getTime() / 1000;
}
const isNotificationOutOfDate = (expiration) => expiration && getCurrentTimeInSeconds() > expiration;
const isSessionVisible = (key) => !isStorageSupported || !sessionStorage.getItem(key);
const isRegularVisible = (key, expiration) => (!StorageService.getItem(key) && !isNotificationOutOfDate(expiration)) ||
    Skubacz.configuration.editing;
function isVisible(key, expiration) {
    const visibilityCheck = (key, expiration) => isSessionNotify(key)
        ? isSessionVisible(key)
        : isRegularVisible(key, expiration);
    if (key === "notify-session-old-browser") {
        // special case for old browser notification
        return isNotSupportedBrowser() && visibilityCheck(key, expiration);
    }
    else {
        return visibilityCheck(key, expiration);
    }
}
/**
 * Persist that a notification was dismissed, so it stays hidden on later visits.
 */
function persistDismissed(key) {
    if (isSessionNotify(key)) {
        if (isStorageSupported) {
            sessionStorage.setItem(key, "true");
        }
    }
    else {
        removeOldNotifications();
        StorageService.setItem(key, getTimestamp());
    }
}
/**
 * Check for `localStorage` support.
 */
function isLocalStorage() {
    const key = "localStorage";
    try {
        localStorage.setItem(key, key);
        localStorage.removeItem(key);
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Check for `sessionStorage` support.
 */
function isSessionStorage() {
    const key = "sessionStorage";
    try {
        sessionStorage.setItem(key, key);
        sessionStorage.removeItem(key);
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Remove old notifications.
 *
 * @param regex Regex to match against localStorage key.
 */
function removeOldNotifications(regex = "notification-") {
    if (isStorageSupported) {
        for (let k in localStorage) {
            if (localStorage.hasOwnProperty(k) && k.match(regex)) {
                StorageService.removeItem(localStorage)(k);
            }
        }
    }
}
function hide(notification, animationDurationInMs) {
    notification.classList.add(notifyElements.notifyHiddenClass);
    setTimeout(() => {
        notification.style.display = "none";
    }, animationDurationInMs);
}
function init() {
    var _a;
    if (isStorageSupported) {
        // TODO/Info: Notification about missing localStorage support probably won't be needed if whole project will use StorageService fallback.
        (_a = document.querySelector(notifyElements.notifyStorageSelector)) === null || _a === void 0 ? void 0 : _a.remove();
    }
    const elements = document.querySelectorAll(notifyElements.notifySelector);
    if (elements.length === 0) {
        return;
    }
    const animationDuration = getComputedStyle(document.querySelector(":root")).getPropertyValue("--base-duration");
    const animationDurationInMs = parseFloat(animationDuration) * 1000;
    elements.forEach((notification) => {
        const key = notification.dataset.notifyKey;
        const expiration = Number(notification.dataset.expiration);
        if (typeof key === "undefined") {
            throw new Error("data-notify-key attribute is required!");
        }
        if (isVisible(key, expiration)) {
            notification.style.display = "block";
        }
        else {
            hide(notification, animationDurationInMs);
        }
        const notificationClose = notification.classList.contains(notifyElements.notifyCloseClassName)
            ? notification
            : notification.querySelector(`.${notifyElements.notifyCloseClassName}`);
        notificationClose.addEventListener("click", (e) => {
            hide(notification, animationDurationInMs);
            persistDismissed(key);
            e.preventDefault();
        });
    });
}
export default {
    init,
};
